import PageSwitcher from './PageSwitcher';

export default PageSwitcher;
